//Core
import React from "react"

//Images
import logo from "../../../images/logo_tas.svg"

//Helpers
import { classes } from "../../../helpers/classname"

//Style
import style from "./style.module.scss"

//Components
import TravelForm from "../../../components/Forms/TravelForm"

const {
  Container,
  TextWrapper,
  Logo,
  PlaneImage,
  Title,
  Subtitle,
  RuleTitle,
  small,
  FormWrapper,
} = style

const Header = () => {
  return (
    <div className={Container}>
      <div className={PlaneImage}></div>
      <div className={TextWrapper}>
        <h1 className={Title}>ВИГРАЙТЕ</h1>
        <h2 className={Subtitle}>ПОДОРОЖ СВОЄЇ МРІЇ</h2>
        <h3 className={RuleTitle}>
          Кожен ваш чек від 500 грн з 1 по 31 березня 2020 - ваш шанс на
          перемогу!
        </h3>
        <h4 className={classes(RuleTitle, small)}>
          Зареєструйтесь для участі в акції:
        </h4>
        <div className={FormWrapper}>
          <TravelForm link="https://refinance.tascombank.ua/api/travel"></TravelForm>
        </div>
      </div>
    </div>
  )
}

export default Header
